import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import {
  ImplementSelectItem, RepairerSelectItem,
  FamilyListItem, ImplementItem, ImplementSelectionFilter,ObservationPointId, FECRAdditionalObsVM, FECRInspectionAdditionalObsVM, FECRPrePostAdditionalObsVM
} from './FECRDashboard/fecr-search-panel/fecr-search-panel.model'
import { DissAssemblyInspectionVM, ExistingProjectContactsVM, ModalObsRecommendation, ProgressReportingInspectionVM, ProjectContactsVM } from './add-fecr-recommendation/add-fecr-recommendation';
import { Tuple } from '../setup-equipment/setup-equipment.model';
import { FECRUserInfo, GenericIdName } from '../setup-implement/setup-implement.model';

@Injectable()
export class FrontEndComponetService {

  private readonly API_BASE = 'api/GETsetupequipment/';
  private readonly GET_CUSTOMER_LIST = this.API_BASE + 'GetCustomerList';
  private readonly GET_JOBSITE_LIST = this.API_BASE + 'GetJobsiteList';
  private readonly GET_EQUIPMENT_LIST = this.API_BASE + 'GetEquipmentList';
  private readonly GET_IMPLEMENT_TYPE = this.API_BASE + 'GetImplementTypes';
  private readonly GET_REPAIRER_LIST = this.API_BASE + 'GetRepairerList';
  private readonly GET_FAMILY_LIST = this.API_BASE + 'GetFamilyList';
  private readonly GET_IMP_LIST = this.API_BASE + 'GetImplementsAvailable';
  private readonly POST_OBS_RECOMMENDATION = this.API_BASE + 'UpdateObsRecommendation';
  private readonly GET_EXISTING_RECOMMENDATION_DATA = this.API_BASE + 'GETExistingRecommendationData';
  private readonly GET__PROGRESS_REPORTING_DATA = 'api/FECRImplement/GETProgressReportingData';
  private readonly POST_PROGRESS_REPORTING_INSPECTION = 'api/FECRImplement/AddNewProgressReportingInspection';
  private readonly GET_DISASSEMBLY_DATA = 'api/FECRImplement/GETDisassemblyInspectionData';
  private readonly POST_DISASSEMBLY_INSPECTION = 'api/FECRImplement/AddNewDisAssemblyInspection';

  

  private readonly GET_FECR_OBSERVATION_TYPES ='api/FECRImplement/GETFecrObservationTypes';
  private readonly GET_FECR_OBSERVATION_HISTORY ='api/FECRImplement/GETFecrObservationHistory';
  private readonly GET_OBS_HISTORY_MENU ='api/FECRImplement/GETObsHistoryMenu';

  private readonly GET_MODELS = this.API_BASE + 'GetModelList';
  private readonly GET_FAMILY_NAME_FOR_MODEL = this.API_BASE + 'GetFamilyNameForModel';
  private readonly GET_EQUIPMENT_RANKING_LIST = this.API_BASE + 'GetEquipmentRankingListAsync';
  private readonly GET_APPLICATION_LIST = this.API_BASE + 'GetEquipmentApplicationListAsync';
  private readonly VALIDATE_SERIAL_UNIT_NUMBER = this.API_BASE + 'ValidateSerialAndUnitNumberAsync';
  private readonly CREATE_NEW_EQUIPMENT = this.API_BASE + 'CreateNewEquipment';
  private readonly GET_EQUIPMENT_SETUP_DETAILS = this.API_BASE + 'GetEquipmentSetupDetails';
  private readonly UPDATE_EQUIPMENT = this.API_BASE + 'UpdateEquipmentAsync';
  private readonly GET_EQUIPMENT_DETAILS = this.API_BASE + 'GetEquipmentDetails';
  private readonly UPDATE_INSPECTION_FORECAST = this.API_BASE + 'UpdateEquipmentInspectionForcast';

  private readonly GET_ACCESIBLE_USERS = 'api/FECRImplement/LoadAccessibleUserList';
  private readonly GET_CONTACT_EVENTS = 'api/FECRImplement/LoadFECRContactEvents';
  private readonly UPDATE_FECRPROJECT_CONTACTS= 'api/FECRImplement/UpdateFECRProjectContacts';
  private readonly GET_EXISITNIG_PROJECT_CONTACTS= 'api/FECRImplement/GetExisitingProjectContacts';
  private readonly DELETE_EXISITNIG_PROJECT_CONTACT= 'api/FECRImplement/RemoveSpecificUserFromProjectContact';
  private readonly GET_PROJECT_PARTS= 'api/FECRImplement/GetProjectPartsList';

  private readonly SAVE_FECR_ADDITIONAL_OBSERVATION ='api/FECRImplement/SaveFECRAdditionalObservation';
  private readonly GET_FECR_ADDITIONAL_OBSERVATION_INSPECTIONTYPE ='api/FECRImplement/GETFECRAdditionalObservation';
  private readonly CREATE_FECR_INSPECTION_PRE_POST='api/FECRImplement/CreateFECRPrePostInspection';
  private readonly GET_FECR_INSPECTION_PRE_POST='api/FECRImplement/GetFECRPrePostInspection';
  private readonly SAVE_FECR_INSPECTION_ADDITIONAL_OBSERVATION ='api/FECRImplement/SaveFECRInspectionAdditionalObservation';




constructor(private _http: Http) { }

public DeleteSelectedUserFromContact(params: ExistingProjectContactsVM): Observable<Tuple> {
  return this._http.post(this.DELETE_EXISITNIG_PROJECT_CONTACT, params).share().map(
    (response: Response) => response.json()).catch(this.handleError);
}
public GETExisitngProjectContacts(ImplementId) {
  let params = { ImplementId: ImplementId };
  return this._http.get(this.GET_EXISITNIG_PROJECT_CONTACTS, { search: params }).share().map(
    (response: Response) => response.json()).catch(this.handleError);
}


public GETProjectPartsList(ImplementId) {
  let params = { ImplementId: ImplementId };
  return this._http.get(this.GET_PROJECT_PARTS, { search: params }).share().map(
    (response: Response) => response.json()).catch(this.handleError);
}
public UpdateFECRProjectContact(params: ProjectContactsVM): Observable<Tuple> {
  return this._http.post(this.UPDATE_FECRPROJECT_CONTACTS, params).share().map(
    (response: Response) => response.json()).catch(this.handleError);
}
  public getAccessibleUserLits(): Observable<FECRUserInfo[]> {
    return this._http.get(this.GET_ACCESIBLE_USERS).share().map(
      (response: Response) => <FECRUserInfo[]>response.json()).catch(this.handleError);
  }

  public getFECRContactEvents(): Observable<GenericIdName[]> {
    return this._http.get(this.GET_CONTACT_EVENTS).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }
  public getImplementTypeList(): Observable<ImplementSelectItem[]> {
    return this._http.get(this.GET_IMPLEMENT_TYPE).share().map(
      (response: Response) => <ImplementSelectItem[]>response.json()).catch(this.handleError);
  }

  public getRepairerList(): Observable<RepairerSelectItem[]> {
    return this._http.get(this.GET_REPAIRER_LIST).share().map(
      (response: Response) => <RepairerSelectItem[]>response.json()).catch(this.handleError);
  }

  public GetFamilyList(): Observable<FamilyListItem[]> {
    return this._http.get(this.GET_FAMILY_LIST).share().map(
      (response: Response) => <FamilyListItem[]>response.json()).catch(this.handleError);
  }



  public GetImplementsAvailable(): Observable<ImplementItem[]> {
    return this._http.get(this.GET_IMP_LIST).share().map(
      (response: Response) => <ImplementItem[]>response.json()).catch(this.handleError);
  }

  public UpdateObsRecommendation(params: ModalObsRecommendation): Observable<Tuple> {
    return this._http.post(this.POST_OBS_RECOMMENDATION, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public AddNewProgressReportingInspection(params: ProgressReportingInspectionVM): Observable<Tuple> {
    return this._http.post(this.POST_PROGRESS_REPORTING_INSPECTION, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public AddNewDisAssemblyInspection(params: DissAssemblyInspectionVM): Observable<Tuple> {
    return this._http.post(this.POST_DISASSEMBLY_INSPECTION, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }
  
  public GETExistingRecommendationData(ObsId) {
    let params = { ObsId: ObsId };
    return this._http.get(this.GET_EXISTING_RECOMMENDATION_DATA, { search: params }).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }




  public GETProgressReportingInspectionData(ObsId,ImplementId) {
   // let params = { ObsId: ObsId };
    let params: URLSearchParams = new URLSearchParams();
    params.set('ObsId', ObsId.toString());
    params.set('ImplementId', ImplementId.toString());
    return this._http.get(this.GET__PROGRESS_REPORTING_DATA, { search: params }).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public GETDisassemblyInspectionData(ObsId,ImplementId) {
    // let params = { ObsId: ObsId };
     let params: URLSearchParams = new URLSearchParams();
     params.set('ObsId', ObsId.toString());
     params.set('ImplementId', ImplementId.toString());
     return this._http.get(this.GET_DISASSEMBLY_DATA, { search: params }).share().map(
       (response: Response) => response.json()).catch(this.handleError);
   }

  public GETFECRInspectionTypes() {
    
    return this._http.get(this.GET_FECR_OBSERVATION_TYPES).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public GETObservationPointDetailsUsingType(implementId, ObservationID) {
    let params={ImplementID:implementId, ObservationID:ObservationID}
    return this._http.get(this.GET_FECR_OBSERVATION_HISTORY,{search:params}).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public GETObsHistoryMenu(implementId, ObservationID) {
    let params={ImplementID:implementId, ObservationID:ObservationID}
    return this._http.get(this.GET_OBS_HISTORY_MENU,{search:params}).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }


  public SaveFECRAdditionalObservation(params: FECRAdditionalObsVM): Observable<Tuple> {
    return this._http.post(this.SAVE_FECR_ADDITIONAL_OBSERVATION, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }


  public GETFECRAdditionalObservationForInspectionType(ImplementTypeId:number, InspecitionTypeId:number) {
    let params={ImplementTypeId:ImplementTypeId, InspecitionTypeId:InspecitionTypeId}
    return this._http.get(this.GET_FECR_ADDITIONAL_OBSERVATION_INSPECTIONTYPE,{search:params}).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }


  public AddNewFECRPrePostInspection(params: FECRInspectionAdditionalObsVM): Observable<FECRInspectionAdditionalObsVM> {
    return this._http.post(this.CREATE_FECR_INSPECTION_PRE_POST, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public GetFECRPrePostInspection(ImplementId:number, InspectionId:number) {
    let params={ImplementId:ImplementId, InspectionId:InspectionId}
    return this._http.get(this.GET_FECR_INSPECTION_PRE_POST,{search:params}).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public UpdateFECRAdditionaObsComment(params: FECRPrePostAdditionalObsVM): Observable<Tuple> {
    return this._http.post('api/FECRImplement/UpdateFECRAdditionaObsComment', params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  public SaveFECRInspectionAdditionalObservation(params: FECRAdditionalObsVM): Observable<Tuple> {
    return this._http.post(this.SAVE_FECR_INSPECTION_ADDITIONAL_OBSERVATION, params).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }
  public DeletFECRInspectionObsPoint(ObPointInspectionId:number) {
    let params={ ObPointInspectionId:ObPointInspectionId}
    return this._http.get('api/FECRImplement/DeleteFECRAdditionaObsPoint',{search:params}).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

}
